import { Breadcrumbs } from "@/components/Breadcrumbs";
import { SettingsContainer } from "@/components/layout/SettingsContainer";
import { contactsFilterCategory } from "@/data/filters/categories/contacts";
import { filterCategories } from "@/data/filters/config";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { XIcon } from "lucide-react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/define/$category",
)({
  component: RouteComponent,
  loader: ({ params }) => {
    const category =
      filterCategories[params.category as keyof typeof filterCategories];
    return {
      crumb:
        category.id !== contactsFilterCategory.id ? category.title : undefined,
      meta: {
        title:
          category.id !== contactsFilterCategory.id
            ? category.title
            : undefined,
      },
      showCampaignSetupBottomBar: false,
    };
  },
});

function RouteComponent() {
  const { category } = Route.useParams();

  return (
    <SettingsContainer>
      <div className="flex h-full flex-col gap-y-10">
        <div className="flex items-center justify-between">
          <Breadcrumbs size="sm" from="/campaigns/$id/define" />

          <Link to={category === "contacts" ? "/campaigns/$id/define" : ".."}>
            <XIcon className="size-5" />
          </Link>
        </div>

        <div className="flex h-full flex-col justify-center">
          <Outlet />
        </div>
      </div>
    </SettingsContainer>
  );
}
